export const coreFrameId = 'core'
export const userConfigKey = 'specific.ids'
